var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { CuratedCards } from '../../CuratedCards/CuratedCards.old';
import { JobsToBeDone } from '../../JobsToBeDone/JobsToBeDone.old';
import TutorialNavigator from '../../quickstarts/TutorialNavigator';
import { SearchBox } from '../../SearchBox/SearchBox.old';
import { Spinner } from '../../Spinner';
import styles from './styles.module.styl';
export var HomePage = function (props) { return (React.createElement("div", { className: styles.homeContainer },
    React.createElement("div", { className: styles.topFold },
        React.createElement("div", { className: "container" },
            React.createElement(SearchBox, { placeholder: "Search the docs" })),
        !props.quickstarts ? (React.createElement(Spinner, null)) : (React.createElement(TutorialNavigator, __assign({ largeHeader: true, firstQuestion: 'Start Building', subHeader: 'Choose your application type to get started', onHomePage: true }, props)))),
    React.createElement(JobsToBeDone, null),
    React.createElement(CuratedCards, { cards: props.cards }))); };
